import {
    SSpinner,
} from './style'

export const Spinner = ({fontSize, height}: {fontSize: string, height: string}) => <SSpinner fontSize={fontSize} height={height}/>